import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;          // "vendor_date" or "order_vendor"
  vendor_from?: string;
  vendor_to?: string;
  order_no_from?: string;
  order_no_to?: string;
  delivery_date_from?: string;   // YYYY-MM-DD
  delivery_date_to?: string;     // YYYY-MM-DD
  product_from?: string;
  product_to?: string;
  undelivered_only?: boolean;
}

export interface ReportRow {
  FD110_12: string;       // vendor code
  vendor_name: string;
  FD110_01: string;       // order no
  FD111_19: string;       // delivery date
  FD111_10: string;       // product code 1
  FD111_11: string;       // product code 2
  product_code: string;   // concatenated
  FD111_17: number;       // unit price
  FD110_19: string;       // unit
  FD111_COL: string;      // color code
  color_name: string;
  order_qty: number;
  delivered_qty: number;
  undeliv_qty: number;
  description: string;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  label: string;
  total_qty: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  summary: UnitSummary[];
  message?: string;
}

export const d309Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d309/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d309/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
